import React, { useState } from 'react';
import { Button } from '../ui/button';

const SpecialPhotosStep = ({ data, updateData, onNext }) => {
  const [selected, setSelected] = useState(data.specialPhotos || '');

  const handleSelect = (value) => {
    setSelected(value);
    updateData('specialPhotos', value);
    setTimeout(() => onNext(), 300);
  };

  return (
    <div className="text-center flex flex-col items-center justify-center min-h-[70vh]">
      {/* Image placeholder */}
      <div className="mb-8 relative">
        <div className="w-72 h-96 rounded-3xl overflow-hidden bg-[#1A1A1A] border border-white/10 shadow-2xl">
          <img
            src='https://assets.fnlfx.com/01K2S1BVK21M1XN0QTA69NGW5Z/ZrAWAM8I.webp'
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
        </div>
      </div>

      <h1 className="text-white text-2xl md:text-3xl font-bold mb-12">
        Would you like to receive special photos?
      </h1>

      <div className="flex gap-4 w-full max-w-sm">
        <Button
          onClick={() => handleSelect('no')}
          className={`flex-1 py-6 rounded-full text-lg font-bold transition-all duration-300 hover:scale-105 ${selected === 'no'
              ? 'bg-white/10 text-white border-2 border-white/30'
              : 'bg-white/5 text-white border border-white/10 hover:border-white/30'
            }`}
        >
          No
        </Button>
        <Button
          onClick={() => handleSelect('yes')}
          className={`flex-1 py-6 rounded-full text-lg font-bold transition-all duration-300 hover:scale-105 ${selected === 'yes'
              ? 'bg-[#F1B428] text-black shadow-lg shadow-[#F1B428]/30'
              : 'bg-white/5 text-white border border-white/10 hover:border-[#F1B428]/50'
            }`}
        >
          Yes
        </Button>
      </div>
    </div>
  );
};

export default SpecialPhotosStep;
